import React, { Component } from 'react';
import { Container, Row, Col, Table } from 'react-bootstrap';
import { strings } from '../../resources/strings';

export class TicketInfo extends Component {
    render() {
        return (
            <Container fluid className="mb-5">
                <Row className="mt-5">
                    <Col>
                        <h3><b>{strings.tickets}</b></h3>
                    </Col>
                </Row>
                <Row>
                    {/*className="pointer-cursor"*/}
                    <Col>
                        <ul>
                            <li>{strings.simpleTicket}</li>
                            <li><a href="ticket-info#normal" className="no-style">{strings.monthly}</a></li>
                            <li><a href="ticket-info#cim" className="no-style">{strings.passCIM}</a></li>
                            <li><a href="ticket-info#sub23" className="no-style">{strings.pass418s23}</a></li>
                            <li><a href="ticket-info#circula" className="no-style">{strings.passCircula}</a></li>
                            <li><a href="ticket-info#combatentes" className="no-style">{strings.passAntigoCombatente}</a></li>
                        </ul>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <a href="docs/ticket_info_tpac.pdf" target="_blank">{strings.ticketsDownload}</a>
                    </Col>
                </Row>
                <Row id="normal" className="padding-top-30">
                    <Col>
                        <h6>{strings.monthly}</h6>

                        <ul>
                            <li>{strings.monthlyConditionsA}</li>
                            <li>{strings.monthlyConditionsB}</li>
                            <li>{strings.monthlyConditionsC}</li>
                            <li>{strings.monthlyConditionsD}</li>
                            <li>{strings.monthlyConditionsE}</li>
                        </ul>

                        <b>{strings.monthlyRequirements}</b>
                        <ul>
                            <li>{strings.monthlyRequirementA}</li>
                            <li>{strings.monthlyRequirementB}</li>
                        </ul>
                    </Col>
                </Row>
                <Row id="cim" className="padding-top-30">
                    <Col>
                        <h6>{strings.passCIM}</h6>
                        <p>
                            <ul>
                                <li>{strings.passCIMConditionA}</li>
                                <li>{strings.passCIMConditionB}</li>
                                <li>{strings.passCIMConditionC}</li>
                                <li>{strings.passCIMConditionD}</li>
                                <li>{strings.passCIMConditionE}</li>
                                <li>{strings.passCIMConditionF} (<a href="https://www.cimac.pt" target="_blank" rel="noopener noreferrer">www.cimac.pt</a>)</li>
                                <li>{strings.passCIMConditionG}</li>
                            </ul>
                        </p>
                        <b>{strings.passCIMRequirements}</b>
                        <ul>
                            <li>{strings.passCIMRequirementA}</li>
                            <li>{strings.passCIMRequirementB}</li>
                        </ul>
                    </Col>
                </Row>
                <Row id="sub23" className="padding-top-30">
                    <Col>
                        <h6>{strings.pass418s23}</h6>
                        {strings.pass418Conditions1}<br />
                        {strings.pass418Conditions2}<br />
                        {strings.pass418Conditions3}<br />
                        <ul>
                            <li>{strings.pass418ConditionA}</li>
                            <li>{strings.pass418ConditionB}</li>
                            <li>{strings.pass418ConditionC}</li>
                            <li>{strings.pass418ConditionD}</li>
                            <li>{strings.pass418ConditionE}</li>
                            <li>{strings.pass418ConditionF}</li>
                                <ul>
                                    <li>{strings.pass418ConditionFA}</li>
                                    <li>{strings.pass418ConditionFB}</li>
                                    <li>{strings.pass418ConditionFC}</li>
                                </ul>
                            <li>{strings.pass418ConditionG}</li>
                        </ul>
                        <b>{strings.pass418Requirements}</b>
                        <ul>
                            <li>{strings.pass418RequirementA}</li>
                            <li>{strings.pass418RequirementB}</li>
                            <li>{strings.pass418RequirementC}</li>
                            <li>{strings.pass418RequirementD}</li>
                        </ul>
                        <b>{strings.pass418Notes}</b>
                        <ul>
                            <li>{strings.pass418NotesA}</li>
                            <li>{strings.pass418NotesB}</li>
                            <li>{strings.pass418NotesC}</li>
                        </ul>
                    </Col>
                </Row>
                <Row id="circula" className="padding-top-30">
                    <Col>
                        <h6>{strings.passCircula}</h6>
                        <ul>
                            <li>{strings.passCirculaConditionA}</li>
                            <li>{strings.passCirculaConditionB}</li>
                            <li>{strings.passCirculaConditionC}</li>
                            <li>{strings.passCirculaConditionD}</li>
                            <li>{strings.passCirculaConditionE}</li>
                            <li>{strings.passCirculaConditionF}</li>
                        </ul>
                        {strings.passCirculaConditionG}<br />
                        <br />
                        <b>{strings.passCirculaDiscounts}</b><br />
                        <u>{strings.passCirculaDiscountsA}</u>
                        <ul>
                            <li>{strings.passCirculaDiscountsAA}</li>
                            <li>{strings.passCirculaDiscountsAB}</li>
                            <li>{strings.passCirculaDiscountsAC}</li>
                        </ul>
                        <u>{strings.passCirculaDiscountsB}</u>
                        <ul>
                            <li>{strings.passCirculaDiscountsBA}</li>
                            <li>{strings.passCirculaDiscountsBB}</li>
                            <li>{strings.passCirculaDiscountsBC}</li>
                        </ul>
                        <b>{strings.passCirculaRequirements}</b>
                        <ul>
                            <li>{strings.passCirculaRequirementA}</li>
                            <li>{strings.passCirculaRequirementB}</li>
                            <li>{strings.passCirculaRequirementC}</li>
                            <li>{strings.passCirculaRequirementD}</li>
                            <li>{strings.passCirculaRequirementE}</li>
                        </ul>
                    </Col>
                </Row>
                <Row id="combatentes" className="padding-top-30">
                    <Col>
                        <h6>{strings.passAntigoCombatente}</h6>
                        <ul>
                            <li>{strings.passAntigoCombatenteConditionA}</li>
                            <li>{strings.passAntigoCombatenteConditionB}</li>
                            <li>{strings.passAntigoCombatenteConditionC}</li>
                            <li>{strings.passAntigoCombatenteConditionD}</li>
                            <li>{strings.passAntigoCombatenteConditionE}</li>
                            <li>{strings.passAntigoCombatenteConditionF}</li>
                            <li>{strings.passAntigoCombatenteConditionG}</li>
                            <li>{strings.passAntigoCombatenteConditionH}</li>
                        </ul>
                        <b>{strings.passAntigoCombatenteRequirements}</b>
                        <ul>
                            <li>{strings.passAntigoCombatenteRequirementA}</li>
                            <li>{strings.passAntigoCombatenteRequirementB}</li>
                            <li>{strings.passAntigoCombatenteRequirementC}</li>
                            <li>{strings.passAntigoCombatenteRequirementD}</li>
                        </ul>
                    </Col>
                </Row>
            </Container>
        );
    }
}